import { render, staticRenderFns } from "./6-FinalisationPage.vue?vue&type=template&id=20cb6cd1"
import script from "./6-FinalisationPage.vue?vue&type=script&lang=js"
export * from "./6-FinalisationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports